import { Button } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { FolderIcon, UploadcheckBox } from "../../assets/svgs";
import { useUser } from "../../contexts";
import { ChooseUploadType } from "../../interfaces";
import AccountLayout from "../../layouts/AccountLayout";
import useOrder from "../../hooks/useOrder";

const UploadType: React.FC = () => {
  const { t } = useTranslation();
  const [user] = useUser();
  const history = useHistory();
  const { handleOrderUpdate } = useOrder();

  const updateChooseUpload = async (type: ChooseUploadType) => {
    await handleOrderUpdate({ id: user.order.id, chooseUpload: type });
  };

  const returnToNew = async () => {
    await updateChooseUpload(ChooseUploadType.bulkUpload);
    history.push("/account/bulkupload");
  };
  const redirectToAccount = async () => {
    await updateChooseUpload(ChooseUploadType.account);
    history.push("/account");
  };

  return (
    <AccountLayout account>
      <div className=" grid  mt-30 row-space-around  row-column-tab-responsive">
        <div className="row row-column row-v-center ">
          <div className=" card card-auto-max row row-column row-v-center row-center max-width-min gap-16">
            <h2 className="text-v-center f-w-700">{t("uploadTitle1")}</h2>
            <UploadcheckBox />
            <p className="text-v-center f-16">{t("uploadContent1")}</p>

            <ul className="ul">
              <h4 className="text-v-center f-16 f-w-700">{t("advantages")}</h4>
              <li>
                <p>{t("uploadPoint1")}</p>
              </li>
              <li>
                <p>{t("uploadPoint2")}</p>
              </li>
              <li>
                <p>{t("uploadPoint3")}</p>
              </li>
              <li>
                <p>{t("uploadPoint4")}</p>
              </li>
            </ul>
            <Button onClick={redirectToAccount} pl={64} pr={64} className="btn">
              {t("uploadNow")}
            </Button>
          </div>
        </div>

        <div className=" row row-v-center row-center p-8">
          <h4 className="f-weight-7">{t("or")}</h4>
        </div>
        <div className="row row-column row-v-center ">
          <div className="card card-auto-max row row-column row-v-center max-width-min gap-64">
            <h2 className="text-v-center f-w-700">{t("uploadTitle2")}</h2>
            <FolderIcon />
            <p className="text-v-center f-16">{t("uploadOwnDeliveryNote")}</p>
            <Button
              className="modal-outlined-button"
              onClick={returnToNew}
              pl={64}
              pr={64}
              variant="outline"
              color="blue"
            >
              {t("uploadNow")}
            </Button>
          </div>
        </div>
      </div>
    </AccountLayout>
  );
};

export default UploadType;
